import React from "react";
import { useTranslation } from "react-i18next";

import sidePanelLogsStyle from "./side-panel-logs.scss";
import { SubworkflowExecutionLogs } from "./SubworkflowExecutionLogs";
import Modal from "components/modal/Modal";
import style from "components/modal/modal.scss";
import { WorkflowEntityType } from "domain/workflows";

import testIds from "testIds.json";

interface SubworkflowLogsModalProps {
    isOpen: boolean;
    onClose: () => void;
    workflowUuid: string;
    contextId: string;
    entityType: WorkflowEntityType;
    secured?: boolean;
}

export function SubworkflowLogsModal(props: SubworkflowLogsModalProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={props.isOpen}
            hideModal={props.onClose}
            modalTitle={t("WorkflowsTable.sidePanel.subworkflows")}
            width="700px"
            closeButton={false}
        >
            <div data-testid={testIds.workArea.workflows.sidePanel.subworkflowExecutionLogsDialog.itself}>
                <div className={`${style.descriptionStyle} ${sidePanelLogsStyle.modalDescription}`}>
                    {t("WorkflowsTable.sidePanel.subworkflowExecutionDescription")}
                </div>
                <SubworkflowExecutionLogs
                    workflowUuid={props.workflowUuid}
                    contextId={props.contextId}
                    entityType={props.entityType}
                    secured={props.secured}
                />
            </div>
        </Modal>
    );
}
